import React, { lazy } from 'react'
import { Navigate, Route } from 'react-router'
import { LoggedInRoute } from '@/router/LoggedInRoute'
import { SubRouter } from '@/router/SubRouter'
import { DocumentationAdminRouter } from './admin/_router'
import { DocumentPageRedirect } from './DocumentPageRedirect'

const Index = lazy(() => import('./Index'))
const DocumentIndex = lazy(() => import('./document/Index'))
const ManualsIndex = lazy(() => import('./manuals/Index'))
const ManualsEditor = lazy(() => import('./manuals/Editor'))

const guarded = (menuItem: `role--${string}`, element: React.ReactNode) => (
  <LoggedInRoute roles={[menuItem]}>{element}</LoggedInRoute>
)

// Documentation : accessible à tout utilisateur connecté ; la visibilité par
// catégorie/document (cascade de rôles) est appliquée côté serveur.
// La gestion (admin/*) est gatée par le menuItem role--documentation--admin.
// Le studio de rédaction des manuels (manuals/*) porte les mêmes rôles que le module
// Compliance — le serveur D1 est gaté par les mêmes autorités.
export const DocumentationRouter = React.memo(() => (
  <SubRouter loggedIn>
    <Route index element={<Index />} />
    <Route path='category/:categoryId' element={<Index />} />
    <Route path='document/:id' element={<DocumentIndex />} />
    {/* Convention interne des modules générés (TOC/LEP/renvois) — voir DocumentPageRedirect. */}
    <Route path='documents/:id' element={<DocumentPageRedirect />} />
    <Route path='admin/*' element={<DocumentationAdminRouter />} />
    {/* Déclarée avant manuals/* : la route statique perdrait sinon face au segment :id. */}
    <Route path='manuals/:id/edit' element={guarded('role--compliance', <ManualsEditor />)} />
    <Route path='manuals' element={<Navigate to='library' replace />} />
    <Route path='manuals/*' element={guarded('role--compliance', <ManualsIndex />)} />
  </SubRouter>
))
